{
  "ACTION": {
    "CLEAR_FILTER": "Effacer",
    "CONTINUE": "Continuer",
    "EDIT": "Modifier",
    "SEND": "Envoyer",
    "VALIDATE": "Valider"
  },
  "ARIA": {
    "MENU": "Menu principal"
  },
  "COMPONENT": {
    "AGENDA-MAGASIN-TUNNEL": {
      "I_WANT_TO_TAKE_MY_APPOINTMENT": "Je veux faire mon rendez-vous",
      "IN_STORE": "En magasin",
      "REMOTELY": "En visio"
    },
    "AVIS-GOOGLE": {
      "OUT_OF": "sur",
      "REVIEWS": "Avis"
    },
    "AVIS-GOOGLE-DETAILS": {
      "AVERAGE_RATING_DISCLAIMER": "Cette note a été obtenue en compilant les <strong>{{nbReviews}} Avis Google*</strong> que nos clients ont laissé sur nos différents magasins dans toute la France à la suite de leur expérience avec SoCoo'c. *Nos avis Google n'ont pas été vérifiés.",
      "AVERAGE_RATING_DISCLAIMER_STORE": "Cette note a été obtenue en compilant les <strong>{{nbReviews}} Avis Google*</strong> que nos clients ont laissé sur notre magasin à la suite de leur expérience avec SoCoo'c. *Nos avis Google n'ont pas été vérifiés.",
      "REVIEWS_STAR": "Les avis {{count}} étoile :",
      "REVIEWS_STARS": "Les avis {{count}} étoiles :",
      "SEE_MORE_REVIEWS": "Voir plus d'avis",
      "SORT_BY_HIGHEST_TO_LOWEST_RATED": "Du mieux noté au moins bien noté :"
    },
    "CARTE-OPPORTUNITES": {
      "OPENING_OPPORTUNITIES": "Opportunités d'ouvertures",
      "OVERSEAS_OPPORTUNITIES": "Nos opportunités en outre-mer",
      "STORES_OPEN": "Magasins ouverts"
    },
    "CONFIRMATION-RDV": {
      "THANK_YOU_RESPONSE": "Merci pour votre réponse"
    },
    "CONFIRMATION-RDV-ESPACE-CLIENT": {
      "ADD_TO_CALENDAR": "J'ajoute à mon agenda",
      "CALENDAR_EVENT_TITLE": "Rendez-vous {{store}}",
      "IMPEDIMENT_TITLE": "Un empêchement ?",
      "IMPEDIMENT_TEXT": "Pensez à nous prévenir afin qu'on ne fasse pas couler le café trop tôt ;) Pour cela rien de plus simple avec mon espace client SoCoo'c, vous pouvez modifier ou annuler votre rendez-vous.",
      "CREATE_ACCOUNT": "Je crée mon compte SoCoo'c",
      "LOGIN": "Je me connecte",
      "MY_ACCOUNT": "J'accède à mon compte SoCoo'c"
    },
    "CONTENU-ARTICLE": {
      "MINUTE": "{{count}} minute",
      "MINUTES": "{{count}} minutes",
      "READING_TIME_LABEL": "Temps de lecture :"
    },
    "ENCART-INFOS-MAGASIN": {
      "CLOSED": "Fermé",
      "EXCEPTIONAL_CLOSURE": "Fermeture exceptionnelle",
      "EXCEPTIONAL_OPENING": "Ouverture exceptionnelle",
      "SHOW_ALL_REVIEWS": "Voir tous les avis"
    },
    "ESTIMATEUR-BUDGET-DETAIL-PRIX": {
      "CALCULATING_CURRENT_PRICE": "Calcul du prix en cours",
      "DELIVERY_INCLUDED": "Livraison incluse",
      "PRICE_BREAKDOWN_DETAIL": "Détail du prix",
      "STARTING_FROM_PER_MONTH": "À partir de {{price}}/mois"
    },
    "ESTIMATEUR-BUDGET-SELECTION": {
      "ESTIMATION_INDEX": "Estimation {{ index }}",
      "HOUSEHOLD_APPLIANCE": "Électroménager",
      "MY_ESTIMATIONS": "Mes estimations",
      "MY_SELECTION": "Ma sélection",
      "PRICE_RANGE": "Entre {{ minPrice }} et {{ maxPrice }}",
      "REQUEST_NEW_ESTIMATE": "Nouvelle estimation",
      "SEND_BY_EMAIL": "Envoyer par mail"
    },
    "ESTIMATEUR-ETAPE": {
      "HEADER": {
        "APPLIANCES_AND_PLUMBING_LABEL": "Électros et sanitaires",
        "DELIVERY_AND_INSTALLATION_LABEL": "Livraison et pose",
        "FURNITURE_LABEL": "Meubles",
        "PRICE_ESTIMATE_LABEL": "Estimation"
      },
      "I_DONT_NEED_ANYTHING": "Je n'ai besoin de rien"
    },
    "FORMULAIRE-CATALOGUE": {
      "CATALOG_SENT_TO_EMAIL": "Votre catalogue vous a été envoyé par email à l'adresse {{ email }}.",
      "CATALOG_WAITING_IN_MAILBOX": "Votre catalogue vous attend dans votre boîte mail.",
      "CHECK_SPAM_IF_NOT_RECEIVED": "Si vous ne l'avez toujours pas reçu après quelques minutes, regardez dans vos spams.",
      "DOWNLOAD_CATALOG": "Télécharger le catalogue",
      "FORM_ERROR": "Erreur lors de l'envoi du formulaire.",
      "LABEL_EMAIL": "Mon adresse mail :"
    },
    "FORMULAIRE-CONTACT-B2B": {
      "DEVELOPER_SECTION_DESCRIPTION": "Sélectionnez le département d'implantation souhaité pour découvrir qui est votre développeur en charge",
      "DEVELOPER_SECTION_TITLE": "Notre équipe de développement à votre service !",
      "LABEL_AREA": "Département d'implantation :",
      "LABEL_EMAIL": "Mon adresse mail :",
      "LABEL_FIRST_NAME": "Mon prénom :",
      "LABEL_LAST_NAME": "Mon nom :",
      "LABEL_MESSAGE": "Un petit message pour nos développeurs :",
      "LABEL_PHONE": "Mon numéro de téléphone :",
      "MESSAGE_CONFIRMATION_RESPONSE_SOON": "Votre message a bien été transmis à nos équipes, nous vous répondrons dans les plus brefs délais.﻿",
      "MESSAGE_HELPER_TEXT": "Donnez-nous quelques précisions sur votre projet : ville(s) d'implantation souhaitée(s), vos expériences, ..."
    },
    "FORMULAIRE-RDV": {
      "FORM_PLACEHOLDER_MESSAGE": "Vous avez déjà rencontré l’un de nos Kitcheners, ou vous souhaitez rencontrer un Kitchener en particulier ?\nVous avez un projet cuisine ? Ou besoin d’information ?",
      "LABEL_APPOINTMENT": "Votre rendez-vous :",
      "LABEL_APPOINTMENT_DATETIME": "à",
      "LABEL_CUSTOM_MESSAGE": "Un petit mot personnalisé ?",
      "LABEL_STORE_LOCATION": "Dans votre magasin ",
      "LABEL_WHEN": "Quand",
      "LABEL_WHERE": "Où",
      "VIDEO_APPOINTMENT_WITH_STORE": "En visio avec votre magasin"
    },
    "HERO-MODELE": {
      "ALL_OUR_FINISHES": "Toutes nos finitions",
      "KITCHEN_LAYOUT_WITH_SURFACE": "Cuisine {{type}} de {{surface}}"
    },
    "HERO-SLIDER": {
      "VIRTUAL_TOUR": "Visite virtuelle"
    },
    "KITCHEN-MODEL-CARD": {
      "SEE_THIS_KITCHEN": "Voir cette cuisine"
    },
    "LISTING-AUTRES-FACADES": {
      "OTHER_FRONTS": "Les autres façades"
    },
    "LISTING-COIN-REPAS": {
      "FROM": "À partir de :",
      "PER_UNIT": "l'unité"
    },
    "LISTING-FACADES": {
      "NO_RESULTS": "Aucun résultat pour ce type de façade."
    },
    "LISTING-MAGASIN": {
      "SEE_THIS_STORE": "Voir ce magasin"
    },
    "LISTING-MEUBLES-IMAGE-NOM-DESCRIPTION": {
      "AVAILABLE_HEIGHTS": "Hauteurs disponibles",
      "AVAILABLE_WIDTHS": "Largeurs disponibles"
    },
    "LISTING-PACK-PRODUITS": {
      "FOR_THE_SET": "L’ensemble",
      "INSTEAD_OF": "Au lieu de :"
    },
    "LISTING-TEMOIGNAGES": {
      "SEE_MORE_TESTIMONIES": "Voir plus de témoignages"
    },
    "MAP-POPIN": {
      "WANT_TO_KNOW_MORE_OPPORTUNITY": "Vous souhaitez en savoir plus sur cette opportunité ?"
    },
    "MENU-BLOG": {
      "THE_BLOG": "Le blog",
      "THE_SECTIONS": "Les rubriques"
    },
    "MENU-TUNNEL": {
      "CONTACT_DETAILS": "Coordonnées",
      "DAY_AND_TIME": "Jour et horaire",
      "STORE": "Magasin"
    },
    "POPIN-ESTIMATION-EMAIL": {
      "ALL_GOOD": "C'est tout bon !",
      "ESTIMATE_SENT_CONFIRMATION": "<p>Votre estimation vous a été envoyée par email à l’adresse {{email}}.</p><p>Si vous ne l’avez toujours pas reçue après quelques minutes, regardez dans vos spams.</p>",
      "MY_EMAIL_ADDRESS": "Mon adresse email",
      "PRIVACY_POLICY_REMINDER": "Pour connaître l'utilisation que nous faisons des données collectées par ce formulaire et exercer vos droits sur vos données personnelles, notamment en matière d’accès et de suppression, veuillez consulter notre <strong><a target=\"_blank\"  class=\"cursor-pointer\" href=\"{{privacyPolicyUrl}}\">charte de confidentialité</a></strong>.",
      "SEND_ESTIMATE": "Envoyer l'estimation",
      "SEND_KITCHEN_ESTIMATE_BY_EMAIL": "Envoyer l'estimation de ma cuisine par email"
    },
    "POPIN-PRICE-DETAIL": {
      "LOADING_PRICE_DETAILS": "Chargement du détail du prix"
    },
    "POPIN-REALISATIONS-CLIENTS": {
      "CREATED_BY": "Réalisée par :",
      "NEXT_KITCHEN": "Cuisine suivante",
      "PREVIOUS_KITCHEN": "Cuisine précédente"
    },
    "SEARCH": {
      "LABEL_MY_CITY": "Ma ville"
    },
    "STORE-LOCATOR": {
      "BOOK_APPOINTMENT": "Prendre rendez-vous",
      "DISTANCE_IN_KM": "À  {{km}} km",
      "PLACEHOLDER_CITY_OR_POSTAL_CODE": "Ville ou code postal",
      "SELECT_THIS_STORE": "Choisir ce magasin",
      "VIDEO_APPOINTMENT_AVAILABLE": "RDV visio disponible"
    },
    "TEXTE-SEO": {
      "SEE_LESS": "Voir moins",
      "SEE_MORE": "Voir plus"
    },
    "TITRE-FILTRES-MODELES": {
      "BUDGET_PLACEHOLDER": "Budget",
      "CHOOSE_ACTION": "Je choisis",
      "KITCHEN_FRONTS_PLACEHOLDER": "les façades",
      "KITCHEN_LAYOUT": "mon implantation",
      "LAYOUT_PLACEHOLDER": "Implantation",
      "OUR_SELECTION": "Notre sélection",
      "PRICE_ASCENDING": "Du moins cher au plus cher",
      "PRICE_DESCENDING": "Du plus cher au moins cher",
      "PRICE_LESS_THAN": "Moins de {{amount}} €",
      "PRICE_MORE_THAN": "Plus de {{amount}} €",
      "PRICE_RANGE": "Entre {{min}} € et {{max}} €",
      "PS_LOVE": "PS : J’adore",
      "RESET_FILTERS": "Réinitialiser les filtres",
      "SEARCH_KITCHEN": "Je cherche une cuisine"
    }
  },
  "ELASTIC_SEARCH": {
    "GET-CABINET-BODIES-QUERY": {
      "CABINET_BODY": "Corps de meuble"
    },
    "GET-COUNTERTOPS-QUERY": {
      "WORKTOPS": "Plans de travail"
    },
    "GET-FRONTS-QUERY": {
      "KITCHEN_FRONTS": "Façades"
    },
    "GET-HANDLES-QUERY": {
      "HANDLES": "Poignées"
    }
  },
  "GLOBAL": {
    "AND": "Et",
    "APPLIANCES_AND_SANITARY": "Electro et sanitaires",
    "BACK": "Retour",
    "BETWEEN": "Entre",
    "BUDGET": "Budget :",
    "CALL_TO_ACTION_CALL_US": "Appelez-nous",
    "CONTACT_STORE_FOR_AVAILABLE_APPOINTMENTS": "Contactez {{storeName}} au <strong><a href=\"{{storePhoneTelLink}}\" style=\"white-space: nowrap;\">{{storePhoneFormatted}}</a></strong> pour connaître les rendez-vous disponibles",
    "CONTACT_STORE_FOR_AVAILABLE_APPOINTMENTS_NO_PHONE": "Contactez {{storeName}} pour connaître les rendez-vous disponibles",
    "CONTACT_US": "Contactez-nous",
    "FIELD_MIN_LENGTH_ERROR": "Veuillez saisir au moins 3 caractères",
    "FINISHES": "Finitions",
    "FORMS": {
      "APPOINTMENT_SERVER_ERROR": "La prise de rendez-vous est momentanément indisponible, nous vous conseillons d'appeler le magasin au {{phone}} ou de réessayer dans quelques instants.",
      "APPOINTMENT_SERVER_ERROR_NO_PHONE": "La prise de rendez-vous est momentanément indisponible, nous vous conseillons de réessayer dans quelques instants.",
      "AREA_REQUIRED_ERROR": "Le département doit être renseigné",
      "CALLBACK_REQUEST_PROMPT": "Souhaitez-vous être rappelé ?",
      "CHECKBOX_REQUIRED_ERROR": "Au moins une option doit être cochée",
      "CITY_REQUIRED_ERROR": "La ville doit être renseignée",
      "EMAIL_INVALID_ERROR": "L'email n'est pas valide",
      "EMAIL_REQUIRED_ERROR": "L'email doit être renseigné",
      "FIRST_NAME_MIN_LENGTH_ERROR": "Le prénom doit contenir au moins 3 caractères",
      "GENDER_REQUIRED_ERROR": "La genre doit être renseigné",
      "INTEREST_REQUIRED_ERROR": "La raison de votre intérêt doit être renseignée",
      "LABEL_CITY": "Ville :",
      "LABEL_EMAIL": "Email :",
      "LABEL_FIRST_NAME": "Prénom :",
      "LABEL_INFORMATION_TYPE": "Type de renseignement :",
      "LABEL_LAST_NAME": "Nom :",
      "LABEL_MESSAGE": "Message :",
      "LABEL_NEWSLETTER_OPTIN": "Souhaitez-vous être informé des actualités et des offres SoCoo'c :",
      "LABEL_OPTIN_EMAIL": "Par E-mail",
      "LABEL_OPTIN_SMS": "Par SMS",
      "LABEL_PHONE": "Téléphone :",
      "LABEL_REQUEST_TYPE": "Type de demande :",
      "LABEL_STORE": "Magasin",
      "LABEL_TITLE_MADAM": "Madame",
      "LABEL_TITLE_MISTER": "Monsieur",
      "LABEL_ZIPCODE": "Code postal :",
      "LAST_NAME_MIN_LENGTH_ERROR": "Le nom doit contenir au moins 2 caractères",
      "MESSAGE_RECEIVED_CONFIRMATION": "Votre message a bien été transmis à nos équipes, nous vous répondrons dans les plus brefs délais.",
      "MESSAGE_REQUIRED_ERROR": "Le message doit être renseigné",
      "PHONE_FORMAT_ERROR": "Le numéro de téléphone n'est pas au bon format",
      "PHONE_REQUIRED_ERROR": "Le numéro de téléphone doit être renseigné",
      "REQUEST_INFORMATION_TYPE_REQUIRED_ERROR": "Le type de renseignement doit être renseigné",
      "REQUEST_ORDER_TYPE_REQUIRED_ERROR": "Le magasin doit être renseigné",
      "REQUEST_TYPE_REQUIRED_ERROR": "Le type de demande doit être renseigné",
      "ZIPCODE_FORMAT_ERROR": "Le code postal n'est pas au bon format",
      "ZIPCODE_NOT_FOUND_ERROR": "Code postal non reconnu, veuillez saisir un autre code postal",
      "ZIPCODE_REQUIRED_ERROR": "Le code postal doit être renseigné"
    },
    "FURNITURE": "Meubles",
    "INCLUDING_ECO_PART": "dont {{price}} d’éco part",
    "INCLUDING_X_ENVIRONMENTAL_TAX": "dont {{environmentalTaxPrice}} d'écopart",
    "INSTALLATION_AND_DELIVERY": "Pose et livraison",
    "KITCHEN": "Cuisine",
    "LOADING_OPENING_HOURS": "Chargement des horaires",
    "LOADING_TIME_SLOTS": "Chargement des créneaux horaires",
    "NO": "Non",
    "PUNCTUATION": {
      "COLON": " :"
    },
    "SEE_MORE": "Voir plus",
    "SEE_MORE_TIME_SLOTS": "Voir plus de créneaux",
    "STORE_CLOSED_TODAY": "Magasin fermé aujourd'hui",
    "STORE_OPEN_TODAY": "Ouvert aujourd'hui",
    "VIEW_PRICE_DETAILS": "Voir le détail du prix",
    "YES": "Oui"
  },
  "MIDDLE_OFFICE": {
    "LOGOUT": "Déconnexion"
  },
  "PRICE": {
    "ECO_PART": "dont {{ecoPart}} d'éco part"
  },
  "SCHEMA_JSON_LD": {
    "BLOG_MENU": "Menu du blog",
    "FOOTER_MENU": "Menu du pied de page",
    "MAIN_MENU": "Menu principal"
  }
}
